import { ReactNode } from "react";
import {
    CampaignOutlined,
    CardGiftcardOutlined,
    DashboardOutlined,
    Description,
    HeadsetOutlined,
    PersonOutlined,
    SettingsOutlined,
    ManageAccountsOutlined,
    PeopleOutlined,
    Payments,
    RequestPage,
    AccessibleOutlined,
    VaccinesOutlined,
} from "@mui/icons-material";
import { RoleBasedState } from "@interfaces/RoleBasedState";
import MenuIcon from "@layouts/MenuIcon";
import { UserRoles } from "@enums/UserRoles";
import { pageRoutes } from "@constants/pageRoutes";

// Make sure to keep the key and iconName strings same
export const MenuIcons: { [key: string]: { iconName: string; iconElement: ReactNode } } = {
    Dashboard: {
        iconName: "Dashboard",
        iconElement: <MenuIcon icon={<DashboardOutlined />} />,
    },
    Campaign: {
        iconName: "Campaign",
        iconElement: <MenuIcon icon={<CampaignOutlined />} />,
    },
    DonationHistory: {
        iconName: "DonationHistory",
        iconElement: <MenuIcon icon={<CardGiftcardOutlined />} />,
    },
    DonorManagement: {
        iconName: "DonorManagement",
        iconElement: <MenuIcon icon={<ManageAccountsOutlined />} />,
    },
    UserManagement: {
        iconName: "UserManagement",
        iconElement: <MenuIcon icon={<PeopleOutlined />} />,
    },
    Payment: {
        iconName: "Payment",
        iconElement: <MenuIcon icon={<Payments />} />,
    },
    RequestPage: {
        iconName: "RequestPage",
        iconElement: <MenuIcon icon={<RequestPage />} />,
    },
    Patient: {
        iconName: "Patient",
        iconElement: <MenuIcon icon={<AccessibleOutlined />} />,
    },
    DeservingItem: {
        iconName: "DeservingItem",
        iconElement: <MenuIcon icon={<VaccinesOutlined />} />,
    },
    Profile: {
        iconName: "Profile",
        iconElement: <MenuIcon icon={<PersonOutlined />} />,
    },
    Settings: {
        iconName: "Settings",
        iconElement: <MenuIcon icon={<SettingsOutlined />} />,
    },
    Report: {
        iconName: "Report",
        iconElement: <MenuIcon icon={<Description />} />,
    },
    Support: {
        iconName: "Support",
        iconElement: <MenuIcon icon={<HeadsetOutlined />} />,
    },
};

const publicProperty: RoleBasedState = {};

const userProperty: RoleBasedState = {
    adminMenu: [],
    donorMenu: [
        { title: "Dashboard", navigateTo: pageRoutes.DASHBOARD_USER, iconName: MenuIcons.Dashboard.iconName },
        { title: "Donation History", navigateTo: pageRoutes.DONATION_HISTORY_USER, iconName: MenuIcons.DonationHistory.iconName },
        // { title: "Reports", navigateTo: pageRoutes.USER_REPORTS, iconName: MenuIcons.Report.iconName },
    ],
    accountMenu: [
        { title: "My Profile", navigateTo: pageRoutes.PROFILE, iconName: MenuIcons.Profile.iconName },
        { title: "Settings", navigateTo: pageRoutes.PROFILE_SETTINGS, iconName: MenuIcons.Settings.iconName },
        // { title: "Support", navigateTo: pageRoutes.SUPPORT, iconName: MenuIcons.Support.iconName },
    ],
};

const callCenterAssociatesProperty: RoleBasedState = {};

const marketingAssociatesProperty: RoleBasedState = {};

const adminProperty: RoleBasedState = {
    adminMenu: [
        { title: "Dashboard", navigateTo: pageRoutes.DASHBOARD_ADMIN, iconName: MenuIcons.Dashboard.iconName },
        { title: "Donors", navigateTo: pageRoutes.DONORS, iconName: MenuIcons.DonorManagement.iconName },
        { title: "Offline Payments", navigateTo: pageRoutes.OFFLINE_PAYMENTS, iconName: MenuIcons.Payment.iconName },
        { title: "Donation History", navigateTo: pageRoutes.DONATION_HISTORY_ADMIN, iconName: MenuIcons.DonationHistory.iconName },
        { title: "Campaigns", navigateTo: pageRoutes.CAMPAIGNS, iconName: MenuIcons.Campaign.iconName },
        { title: "Refund Requests", navigateTo: pageRoutes.REFUND_REQUEST, iconName: MenuIcons.RequestPage.iconName },
        // { title: "Patients", navigateTo: pageRoutes.PATIENTS, iconName: MenuIcons.Patient.iconName },
        // { title: "Deserving Items", navigateTo: pageRoutes.DESERVING_ITEMS, iconName: MenuIcons.DeservingItem.iconName },
        { title: "Reports", navigateTo: pageRoutes.ADMIN_REPORTS, iconName: MenuIcons.Report.iconName },
        { title: "Users", navigateTo: pageRoutes.USERS, iconName: MenuIcons.UserManagement.iconName },
    ],
    donorMenu: [...(userProperty.donorMenu ?? [])],
    accountMenu: [...(userProperty.accountMenu ?? [])],
};

export const getRoleBasedProperty = (role?: UserRoles) => {
    switch (role) {
        case UserRoles.ADMIN:
            return adminProperty;
        case UserRoles.USER:
            return userProperty;
        case UserRoles.CCA:
            return callCenterAssociatesProperty;
        case UserRoles.MA:
            return marketingAssociatesProperty;
        default:
            return publicProperty;
    }
};
